import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  ButtonGroup,
  UncontrolledDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";

const ServicePages = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  return (
    <React.Fragment>
      <ButtonGroup>
        <UncontrolledDropdown
          // onMouseOver={() => setDropdownOpen(true)}
          // onMouseLeave={() => setDropdownOpen(false)}
          isOpen={dropdownOpen}
          toggle={toggle}
          className=" header-item topbar-user "
        >
          <DropdownToggle tag="span" className="text">
            <Link>
              What We Do <i className="ri-arrow-down-s-fill "></i>
            </Link>
          </DropdownToggle>
          <DropdownMenu className="border-0">
            <DropdownItem
              to="/services/erp-business-software"
              tag={Link}
              style={{ color: "#212529" }}
            >
              ERP Business Software
            </DropdownItem>

            <DropdownItem divider />

            <DropdownItem
              to="/services/web-design"
              tag={Link}
              style={{ color: "#212529" }}
            >
             Web Design
            </DropdownItem>

            <DropdownItem divider />

            <DropdownItem
              tag={Link}
              to="/services/web-development"
              style={{ color: "#212529" }}
            >
              Web Development
            </DropdownItem>

            <DropdownItem divider />

            <DropdownItem
              tag={Link}
              to="/services/digital-marketing"
              style={{ color: "#212529" }}
              className="dropdown-link"
            >
              Digital Marketing
            </DropdownItem>

            <DropdownItem divider />
            <DropdownItem
              tag={Link}
              to="/services/web-application-development"
              style={{ color: "#212529" }}
              className="dropdown-link"
            >
              Web App Development
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem
              tag={Link}
              to="/services/video-editing-marketing"
              style={{ color: "#212529" }}
              className="dropdown-link"
            >
              Video Editing Marketing
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </ButtonGroup>
    </React.Fragment>
  );
};

export default ServicePages;
